<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 7</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Historie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Uiteraard is ook dit weer een plek vol chiroverhalen. Je herinnert je ongetwijfeld leuke chirospelletjes op de speelplaats of op het voetbalveldje. Maar wist je dat de chiro vroeger niet gemengd was? Er was toen een aparte jongens- en meisjeschiro. De jongens zaten in de lokalen waar de chiro nog altijd zit. De meisjes zaten hier aan de Paalstraat in de lokalen boven ‘het medisch centrum’.                 
                </p>
                <p class="text-center d-block margin">
                    Zou jij dat leuk vinden? Aparte spelletjes voor meisjes en jongens? Wat doe je liever zonder ‘het andere geslacht’?                  
                </p>
            </div>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte8'">Volgende stop</button>
    </div>
</div>